import { JSX } from 'react';
import { translationClasses } from 'src/shared/TranslationClasses';
import { C18AudioAssetProps } from './C18AudioAsset.types';
import { CreateAudioAssetModel } from './C18AudioAsset.service';
import { AudioAsset } from '@ahc-digital/component-library';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C18AudioAssetProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const model = CreateAudioAssetModel(props);

  return (
    <AudioAsset
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
      {...model}
    />
  );
};

export default checkDatasourceForRendering<C18AudioAssetProps>(Default);
